export default __webpack_public_path__ + "static/media/404.3b92f3c2.svg";